module.exports = __webpack_public_path__ + "img/8a_asia.21c9534f.png";